module.exports = __webpack_public_path__ + "images/onboarding-banner/error-and-cloud.5a179ab7db259b6d2864.svg";